export default __webpack_public_path__ + "static/media/R870_8.42228d04.png";